import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M15 19.25L18 19.25C18.6904 19.25 19.25 18.6904 19.25 18L19.25 15" />
		<Path opacity=".25" d="M9 4.75L6 4.75C5.30965 4.75 4.75 5.30964 4.75 6L4.75 9M15 4.75L18 4.75C18.6904 4.75 19.25 5.30964 19.25 6L19.25 9M4.75 15L4.75 18C4.75 18.6904 5.30964 19.25 6 19.25L9 19.25" />
	</SVG>
);
